import { usePortal } from "../../Providers/PortalProvider";
import React from "react";
import clsx from "clsx";
const isHighlighted = (highlight, value) => Array.isArray(highlight) ? highlight.includes(value) : highlight === value;
const Address = ({ address, className, highlight }) => {
    const { locale } = usePortal();
    const { twoLetterCode } = locale.country;
    if (twoLetterCode == "US") {
        return React.createElement(AddressUS, { address: address, highlight: highlight });
    }
    if (twoLetterCode == "GB") {
        return React.createElement(AddressGB, { address: address, highlight: highlight });
    }
    return (React.createElement("address", { className: className },
        React.createElement("span", { className: clsx("address--name", isHighlighted(highlight, "name") && "address--highlight") }, address.name),
        React.createElement("br", null),
        React.createElement("span", { className: "address--address" },
            address.address1,
            React.createElement("br", null),
            address.address2 && (React.createElement(React.Fragment, null,
                address.address2,
                React.createElement("br", null))),
            React.createElement(React.Fragment, null,
                address.postalCode,
                " ",
                address.city),
            React.createElement("br", null),
            address.state && (React.createElement(React.Fragment, null,
                address.state,
                React.createElement("br", null))))));
};
const AddressUS = ({ address, highlight }) => {
    return (React.createElement("address", null,
        React.createElement("span", { className: clsx("address--name", isHighlighted(highlight, "name") && "address--highlight") }, address.name),
        React.createElement("br", null),
        React.createElement("span", { className: "address--address" },
            address.address1,
            React.createElement("br", null),
            address.address2 && (React.createElement(React.Fragment, null,
                address.address2,
                React.createElement("br", null))),
            address.city,
            ", ",
            address.state,
            " ",
            address.postalCode),
        React.createElement("br", null)));
};
const AddressGB = ({ address, highlight }) => {
    return (React.createElement("address", null,
        React.createElement("span", { className: clsx("address--name", isHighlighted(highlight, "name") && "address--highlight") }, address.name),
        React.createElement("br", null),
        React.createElement("span", { className: "address--address" },
            address.address1,
            React.createElement("br", null),
            address.address2 && (React.createElement(React.Fragment, null,
                address.address2,
                React.createElement("br", null))),
            React.createElement(React.Fragment, null, address.city),
            React.createElement("br", null),
            React.createElement(React.Fragment, null, address.postalCode),
            React.createElement("br", null)),
        React.createElement("br", null)));
};
export default Address;
